import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronRight } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background with gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0B0B0B] via-[#111111] to-[#0B0B0B]">
        {/* Subtle gold accent overlay */}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(212,175,55,0.03),transparent_50%)]"></div>
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_70%_50%,rgba(212,175,55,0.02),transparent_50%)]"></div>
      </div>

      {/* Logo watermark */}
      <div className="absolute inset-0 flex items-center justify-center opacity-5">
        <img
          src="/images/deus-logo.png"
          alt=""
          className="w-full max-w-4xl h-auto object-contain" />

      </div>

      {/* Content */}
      <div className="relative z-10 container-luxury text-center py-32">
        <div className="max-w-5xl mx-auto space-y-8 animate-fade-in-up">
          {/* Badge */}
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-[#111111] border border-[#D4AF37]/20 rounded-full">
            <span className="w-2 h-2 bg-[#D4AF37] rounded-full animate-pulse"></span>
            <span className="text-sm text-[#D4AF37] font-medium tracking-wider">ИНФОРМИРАНИЯТ ИЗБОР</span>
          </div>

          {/* Main Heading */}
          <h1 className="heading-luxury text-balance !text-4xl">
            Информираният избор при{' '}
            <span className="gradient-text">недвижими имоти</span>
            {' '}и инвестиции
          </h1>

          {/* Subheading */}
          <p className="text-lg lg:text-xl text-[#A9A9A9] max-w-3xl mx-auto leading-relaxed">
            Покупка, продажба, наеми, парцели, анализи, правни и финансови решения — 
            цялостен процес с гарантирана сигурност и прозрачност.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <a href="tel:+359877500793" className="btn-primary group">
              Обади се
              <ArrowRight className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            <Link to="/contact?type=evaluation" className="btn-secondary group">
              Оцени имот безплатно
              <ChevronRight className="ml-2 w-5 h-5 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-12 left-1/2 -translate-x-1/2 animate-bounce">
          <div className="w-6 h-10 border-2 border-[#D4AF37]/30 rounded-full flex items-start justify-center p-2">
            <div className="w-1 h-2 bg-[#D4AF37] rounded-full"></div>
          </div>
        </div>
      </div>
    </section>);

};

export default HeroSection;